import style from './P2PContactList.css';
import List from '../../shared/List/List';
import ListItem from '../../shared/List/ListItem';
import useTranslation from '../../../localization/i18n.context';
import ContactIcon from '../../shared/Icons/ContactIcon';
import P2PEmptyContactList from '../P2PEmptyContactList/P2PEmptyContactList';
import NavigationUtils from '../../../utils/navigation.utils';

export default function P2PContactList({
  className = '',
  contacts = [],
  search = '',
  onGoToSettingsButtonClick,
  permissionGranted,
  cardUid,
}) {
  const { t, getOrganization } = useTranslation();
  const title = t('Contacts in {company_name}', {
    '{company_name}':
      getOrganization(NavigationUtils.getOrganizationCode()) ?? '',
  });

  return (
    <div className={`${className} ${style.container}`}>
      {search.length > 0 && contacts.length > 0 && (
        <p className={style.title}>{title}</p>
      )}

      {search.length === 0 && <p className={style.title}>{title}</p>}

      {contacts.length === 0 && (
        <P2PEmptyContactList
          className={style.contacts}
          search={search}
          permissionGranted={permissionGranted}
          onGoToSettingsButtonClick={onGoToSettingsButtonClick}
        />
      )}
      {contacts.length > 0 && (
        <List className={style.list}>
          {contacts.map(contact => (
            <ListItem
              icon={
                <div className={style.itemIcon}>
                  <ContactIcon />
                </div>
              }
              key={contact.id}
              className={className}
              title={contact.name}
              titleClassName={style.itemTitle}
              subtitle={`+${contact.phone}`}
              actionable={true}
              onClick={() =>
                NavigationUtils.navigate(
                  NavigationUtils.Routes.P2P_CONTACT_CARD_LIST.replace(
                    ':contactUserId',
                    contact.id,
                  ).replace(':cardUid', cardUid),
                  false,
                )
              }
            />
          ))}
        </List>
      )}
    </div>
  );
}
